export var MetricsColorEnum;
(function (MetricsColorEnum) {
    MetricsColorEnum["None"] = "None";
    MetricsColorEnum["Error"] = "Error";
    MetricsColorEnum["Warning"] = "Warning";
    MetricsColorEnum["Success"] = "Success";
})(MetricsColorEnum || (MetricsColorEnum = {}));
//# sourceMappingURL=metrics-color.js.map